export default __webpack_public_path__ + "static/media/layer.48a063f2.svg";